// ApplyFormContainer.tsx

import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { ApplyFormComponent1 } from '@/components/monthly/ApplyFormComponent1';
import { ApplyFormComponent2 } from '@/components/monthly/ApplyFormComponent2';
import { ApplyFormComplete } from '@/components/monthly/ApplyFormComplete';

export const ApplyFormContainer: React.FC = () => {
  const { room_id } = useParams<{ room_id: string }>();

  const [currentStep, setCurrentStep] = useState(1);
  const [formData, setFormData] = useState<any>({});

  // Step 1 のバリデーション成功時に呼ばれる関数
  const handleForm1Next = (data: any) => {
    // 受け取ったデータをそのまま設定し、次のステップへ進む
    setFormData(data);
    // Step2 に進む
    setCurrentStep(2);

    // ★ 画面を一番上までスクロールさせる
    window.scrollTo(0, 0);
  };

  // Step 2 の「Enter」ボタン押下時に呼ばれる関数
  const handleForm2Next = () => {
    // TODO:エラーハンドリング
    setCurrentStep(3);
  };

  // 戻るボタンの処理
  const handleBack = () => {
    setCurrentStep(currentStep - 1);
  };

  return (
    <>
      {currentStep === 1 && <ApplyFormComponent1 onNext={handleForm1Next} />}
      {currentStep === 2 && (
        <ApplyFormComponent2
          formData={formData}
          onNext={handleForm2Next}
          onBack={handleBack}
        />
      )}
      {currentStep === 3 && <ApplyFormComplete />}
    </>
  );
};
